<template>
    <div class="lb-full-height is-clipped">
        <!--<div class="grey-zone"></div>-->
        <div class="logo-zone">
            <img class="back-image" :src="require('@/assets/images/eduloc360_background.png')"/>
        </div>
        <div class="content-zone-creation">
           
            <creation-options
                class="container px-4" 
                @click="loadCreationTemplate"
            />
        </div>

        <launch-app-modal
            v-if="showAppModal"
                class="" 
                :isAndroid="osAndroid"
                :isIOS="osIOS"
            />

        <!--<div class="has-background-pale-grey lb-full-height is-clipped">
        <section
            class="has-scroll-y is-scroll-hidden"
            style="padding: 2em; height: 100%"
        >
            <div class="columns is-centered">
                <div class="column is-10-tablet is-12-desktop">
                    <div class="step-content has-text-centered">
                        <creation-options
                            class="pb-6"
                            @click="loadCreationTemplate"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>-->

    </div>
</template>

<script>
import CreationOptions from '@/components/CreationOptions';
import CreationConfiguration from '@/components/CreationConfiguration';
import LaunchAppModal from '@/components/LaunchAppModal';
import { createItem } from '@/services/API';
import { isMobileOnly,isAndroid,isIOS } from 'mobile-device-detect';
import _ from 'underscore';
export default {
    components: { CreationOptions, CreationConfiguration, LaunchAppModal },
    data() {
        return {
            type: null,
            isConfigured: false,
            creating: false,
            showAppModal: isMobileOnly,
            osAndroid: isAndroid,
            osIOS: isIOS,
        };
    },
    computed: {
        typeSelected() {
            return !!this.configuration.type;
        },
    },
    methods: {
        loadCreationTemplate: _.throttle(async function (projectData) {
            if (this.creating) {
                return;
            }

            let currentLocale = this.$i18n.locale;
            if (currentLocale == 'ca-ES') {
                currentLocale = 'ca';
            }
            // console.log("projectData",projectData)
            this.creating = true;
            // this.$Progress.start();
            let projectFormat = 'PROJECT_TYPE_WALL';
            if (projectData.type.type == 'collection' && !projectData.type.mode) {
                projectFormat = 'PROJECT_TYPE_WALL';
            } else if (projectData.type.type == 'collection' && projectData.type.mode == 'map') {
                projectFormat = 'PROJECT_TYPE_MAP';
            } else if (projectData.type.type == 'trivial' && projectData.type.mode == 'map') {
                projectFormat = 'PROJECT_TYPE_GEOQUIZ';
            } else if (projectData.type.type == 'trivial' && !projectData.type.mode) {
                projectFormat = 'PROJECT_TYPE_QUIZ';
            } else if (projectData.type.type == 'treasurehunt') {
                projectFormat = 'PROJECT_TYPE_TREASUREHUNT';
            } else if (projectData.type.type == 'storytelling') {
                projectFormat = 'PROJECT_TYPE_STORYTELLING';
            } else if (projectData.type.type == 'timemachine') {
                projectFormat = 'PROJECT_TYPE_TIMEMACHINE';
            } else if (projectData.type.type == 'scape') {
                projectFormat = 'PROJECT_TYPE_SCAPE';
            }else if (projectData.type.type == 'memory') {
                projectFormat = 'PROJECT_TYPE_MEMORY';
            }else if (projectData.type.type == 'quizhunt') {
                projectFormat = 'PROJECT_TYPE_QUIZHUNT';
            }
            let projectDataToSend = {
                type: projectData.type.type,
                title: projectData.title,
                description: projectData.description,
                mode: projectData.type.mode,
                folder: this.$route.query.folder,
                format: projectFormat
            }
            if (projectData.langs) {
                //console.log("assigning langs")
                projectDataToSend.langs = projectData.langs;
                projectDataToSend.defaultLang = projectData.defaultLang;
                projectDataToSend.titlePerLang = {};
                projectDataToSend.titlePerLang[projectData.defaultLang] = projectData.title;
                projectDataToSend.descriptionPerLang = {};
                projectDataToSend.descriptionPerLang[projectData.defaultLang] = projectData.description;
            }
            // console.log("projectDataToSend",projectDataToSend)
            let response = this.$store
                .dispatch('createProject', projectDataToSend)
                .then((response) => {
                    /*if (response.data.mode == 'map') {
                        this.$router.push({
                            name: 'project-edit',
                            params: { projectId: response.data._id },
                        });
                    }else */if(response.data.type == "treasurehunt"){
                        // console.log("in treasurehunt creation");
                        const initialObject = {
                            'order': 0,
                            'owner': this.$store.getters.user.owner,
                            'project': response.data._id,
                            'triggers': {'NEXT':''},
                            'title': `${this.$t('creation_first_object_title')}`
                        };
                        createItem('object', initialObject);
                        this.$router.push({
                            name: 'project',
                            params: { projectId: response.data._id },
                        });
                    } else {
                        this.$router.push({
                            name: 'project',
                            params: { projectId: response.data._id },
                        });
                    }
                })
                .catch((e) => {
                    console.log('catch', e);
                    // this.$Progress.fail();
                })
                .finally(() => {
                    this.creating = false;
                });
        }, 750),
    },
    mounted: function () {
        // console.log("is isMobileOnly",isMobileOnly)
        // console.log("is isAndroid",isAndroid)
        // console.log("is isIOS",isIOS)
        if(isMobileOnly){
            
        }
    },
};
</script>
<style scoped>
    .content-zone-creation{
        position: absolute;
        top: 0;
        max-height: calc(100vh - 60px);
        height: calc(100vh - 60px);
        overflow-y: auto;
        overflow-x: hidden;
        padding-left: 5rem;
        padding-right: 5rem;
        padding-top: 2rem;
        padding-bottom: 2rem;
    }
    @media screen and (min-width: 1216px) {
        .content-zone-creation {
            padding-left: calc( (100vw - 1152px ) / 2);
            padding-right: calc( (100vw - 1152px ) / 2);
        }
    }
    @media screen and (min-width: 1024px) {
        .content-zone-creation {
            padding-left: calc( (100vw - 960px ) / 2);
            padding-right: calc( (100vw - 960px ) / 2);
        }
    }

</style>